import { ProfileInfoFieldType } from '../../../Widget'
import {
  USER_PROFILE_INFO_ADDRESS_2_FIELD_NAME,
  USER_PROFILE_INFO_ADDRESS_FIELD_NAME,
  USER_PROFILE_INFO_CITY_FIELD_NAME,
  USER_PROFILE_INFO_COUNTRY_FIELD_NAME,
  USER_PROFILE_INFO_POSTCODE_FIELD_NAME,
  USER_PROFILE_INFO_STREET_FIELD_NAME,
} from '../UserProfileWidget.constants'

export const POST_ADDRESS_FIELDS = [
  {
    labelKey: 'Widget.InfoPostalAddressLabelKey',
    maxLength: 500,
    name: USER_PROFILE_INFO_ADDRESS_FIELD_NAME,
    placeholderKey: 'Widget.InfoPostalAddressPlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoStreetLabelKey',
    maxLength: 245,
    name: USER_PROFILE_INFO_STREET_FIELD_NAME,
    placeholderKey: 'Widget.InfoStreetPlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoDoorNumberLabelKey',
    maxLength: 500,
    name: USER_PROFILE_INFO_ADDRESS_2_FIELD_NAME,
    placeholderKey: 'Widget.InfoDoorNumberPlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoPostCodeLabelKey',
    maxLength: 10,
    name: USER_PROFILE_INFO_POSTCODE_FIELD_NAME,
    placeholderKey: 'Widget.InfoPostCodePlaceholderKey',
    type: ProfileInfoFieldType.INPUT,
  },
  {
    labelKey: 'Widget.InfoCityLabelKey',
    maxLength: 245,
    name: USER_PROFILE_INFO_CITY_FIELD_NAME,
    placeholderKey: 'Widget.InfoCityPlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoCountryLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_COUNTRY_FIELD_NAME,
    placeholderKey: 'Widget.InfoCountryPlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
]
